// PartsRollupSummary — labels everything as Estimate / Suggested.
import type { PartsRollupSection } from '@/lib/parts-financial/calculator';

const fmt = (n: number) =>
  n.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

interface Props {
  rollup: PartsRollupSection;
  title?: string;
  compact?: boolean;
}

export function PartsRollupSummary({ rollup, title = 'Parts Estimate', compact }: Props) {
  return (
    <div className={`rounded-lg border bg-muted/20 ${compact ? 'p-3' : 'p-4'} space-y-1.5`}>
      <div className="flex items-center justify-between text-xs uppercase tracking-wide text-muted-foreground">
        <span>{title}</span>
        <span className="opacity-70">Estimate · not final</span>
      </div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
        <Row label="Parts subtotal" value={fmt(rollup.partsSubtotal)} />
        <Row label="Core charges" value={fmt(rollup.coreSubtotal)} />
        <Row label="Est. fees" value={fmt(rollup.estFees)} />
        <Row label="Est. tax" value={fmt(rollup.estTax)} />
      </div>
      <div className="border-t pt-2 mt-1 flex items-center justify-between">
        <span className="text-sm font-medium">Estimated total</span>
        <span className="text-base font-semibold tabular-nums">{fmt(rollup.estTotal)}</span>
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-muted-foreground">{label}</span>
      <span className="tabular-nums">{value}</span>
    </div>
  );
}
